import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Provider } from 'src/app/models/provider.model';
import { BackgroundService } from "src/app/services/background.service";
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  selector: 'app-background-image',
  templateUrl: './background-image.component.html',
  styleUrls: ['./background-image.component.css'],
  standalone: false
})
export class BackgroundImageComponent implements OnInit, OnDestroy {
  @HostBinding('style.background-image')
  get backgroundImage(): SafeStyle {
    return this.domSanitizer.bypassSecurityTrustStyle(
      `url(${this.backgroundImageURL})`
    );
  }

  private backgroundImageURL = "";
  private providerSubscription = new Subscription();

  constructor(
    private domSanitizer: DomSanitizer,
    private backgroundService: BackgroundService,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    this.setBackgroundImage(this.registrationService.getProvider() || null);
    this.providerSubscription = this.registrationService.provider$.subscribe((provider) => {
      this.setBackgroundImage(provider);
    });
  }

  ngOnDestroy(): void {
    this.providerSubscription.unsubscribe();
  }

  private setBackgroundImage(provider: Provider | null): void {
    this.backgroundImageURL = provider?.customPwaImage || "/assets/" + this.backgroundService.getImage();
  }
}
